import { useLoadableAction } from '@higherlogic/ocfe/src/utilHooks';
import { isLoading, isLoadSuccess } from '@higherlogic/ocfe/src/utils';
import { useCallback } from 'react';
import OcApiRequest from 'src/Api/OcApiRequest';
import { FilePickerConfig } from 'src/FilePicker/FilePickerConfig';

export const loadFilePickerConfig = (): Promise<FilePickerConfig> => {
    return OcApiRequest.get<FilePickerConfig>('/shared/filePicker/filePickerImageUploadConfig');
};

export const useFilePickerConfig = () => {
    const [filePickerConfigLoadable, doLoadFilePickerConfig] = useLoadableAction(loadFilePickerConfig);
    const load = useCallback(() => {
        if (!isLoadSuccess(filePickerConfigLoadable) && !isLoading(filePickerConfigLoadable)) {
            doLoadFilePickerConfig();
        }
    }, [doLoadFilePickerConfig, filePickerConfigLoadable]);
    return [filePickerConfigLoadable, load] as const;
};
